/**
 * Workflows API
 * Domain API via HTTP transport (apiTransport) to the backend /api RPC.
 */

import { Workflow, WorkflowExecutionLog } from '@repo/shared-types';
import { apiTransport as router } from './transport';
import { getContext } from './core';

export const workflowsApi = {
  list: async () => router.get<Workflow[]>('/workflows'),
  get: async (id: string) => router.get<Workflow>(`/workflows/${id}`),
  create: async (workflow: Workflow) => {
    const context = getContext();
    return router.post<Workflow>('/workflows', workflow, context);
  },
  update: async (id: string, updates: Partial<Workflow>) => {
    const context = getContext();
    return router.patch<Workflow>(`/workflows/${id}`, updates, context);
  },
  delete: async (id: string) => {
    const context = getContext();
    return router.delete<{ success: boolean }>(`/workflows/${id}`, context);
  },
  execute: async (workflowId: string, triggerData?: import('@repo/shared-types/workflow').WorkflowTriggerData) => {
    const context = getContext();
    return router.post<{ success: boolean; logId?: string; error?: string }>(`/workflows/${workflowId}/execute`, triggerData, context);
  },
  runAll: async () => {
    const context = getContext();
    return router.post<{ executed: number; failed: number }>('/workflows/run-all', {}, context);
  },
  logs: {
    list: async () => router.get<WorkflowExecutionLog[]>('/workflows/logs'),
    create: async (log: WorkflowExecutionLog) => {
      const context = getContext();
      return router.post<WorkflowExecutionLog>('/workflows/logs', log, context);
    }
  }
};

